import { useContext } from 'react';
import _ from 'lodash';
import { ButtonGroup, ButtonToolbar } from 'reactstrap';
import { mapModes, measurementModes } from '../../constants/map';
import { MapContext } from '../../contexts/MapContext';
import { useUnits } from '../../contexts/UnitContext';
import {
  feetPerMile,
  LARGE_DISTANCE_UNITS,
  DISTANCE_UNITS,
  AREA_UNITS,
  SMALL_AREA_UNITS,
  acresPerSqFt,
} from '../../constants/units';
import SelectionButton from '../basics/SelectionButton';
import LineIcon from '../icons/LineIcon';
import PolygonIcon from '../icons/PolygonIcon';
import { SHORTCUTS } from '../../constants/shortcuts';
import ButtonWithShortcut from '../basics/ButtonWithShortcut';

const measurementButtons = [
  {
    mode: measurementModes.DISTANCE,
    icon: <LineIcon />,
    shortcutKey: SHORTCUTS.MEASURE_DISTANCE.key,
  },
  {
    mode: measurementModes.AREA,
    icon: <PolygonIcon />,
    shortcutKey: SHORTCUTS.MEASURE_AREA.key,
  },
];

const getSetMeasurementMode = (currentMode, newMode, setMapMode) => () => {
  if (currentMode !== newMode) {
    setMapMode(mapModes.MEASUREMENT, null, {
      measurementMode: newMode,
    });
  }
};

const FormattedDistance = ({ distance }) => {
  const units = distance > 0.2 ? LARGE_DISTANCE_UNITS : DISTANCE_UNITS;
  const displayDistance =
    units === DISTANCE_UNITS ? (distance * feetPerMile).toFixed(0) : distance;
  const { displayUnit, transformToUnit } = useUnits(units);

  return (
    <>
      {transformToUnit(displayDistance)} {displayUnit}
    </>
  );
};

const FormattedArea = ({ area }) => {
  const units = area > 0.2 ? AREA_UNITS : SMALL_AREA_UNITS;
  const displayArea =
    units === SMALL_AREA_UNITS ? (area / acresPerSqFt).toFixed(0) : area;
  const { displayUnit, transformToUnit } = useUnits(units);

  return (
    <>
      {transformToUnit(displayArea)} {displayUnit}
    </>
  );
};

const MeasurementToolbar = () => {
  const {
    mapState: {
      setMapMode,
      context: {
        measurementMode = measurementModes.DISTANCE,
        distance = 0,
        area = 0,
      },
    },
  } = useContext(MapContext);

  return (
    <ButtonToolbar className="d-flex align-items-center">
      <ButtonGroup>
        {measurementButtons.map(({ mode, icon, shortcutKey }) => (
          <SelectionButton
            key={mode}
            as={ButtonWithShortcut}
            selected={measurementMode === mode}
            size="sm"
            onClick={getSetMeasurementMode(measurementMode, mode, setMapMode)}
            shortcut={shortcutKey}
          >
            {icon}
          </SelectionButton>
        ))}
      </ButtonGroup>
      <ButtonWithShortcut
        shortcut={SHORTCUTS.CLOSE.key}
        color="primary"
        onClick={() => {
          setMapMode(mapModes.VIEW);
        }}
        size="sm"
        className="ml-2"
      >
        Done
      </ButtonWithShortcut>
      <div className="ml-4 text-">
        {_.capitalize(measurementMode)}:{' '}
        {measurementMode === measurementModes.DISTANCE ? (
          <FormattedDistance distance={distance} />
        ) : (
          <FormattedArea area={area} />
        )}
      </div>
    </ButtonToolbar>
  );
};

export default MeasurementToolbar;
